export class MigrationError extends Error {
  constructor(
    public readonly errorCode:
      | "VALIDATION_ERROR_BEFORE_MIGRATION"
      | "VALIDATION_ERROR_AFTER_MIGRATION"
      | "MIGRATION_UNNECESSARY",
    public readonly errorDetail: string[],
  ) {
    super();

    // https://www.dannyguo.com/blog/how-to-fix-instanceof-not-working-for-custom-errors-in-typescript/
    Object.setPrototypeOf(this, MigrationError.prototype);
  }
}
